import { baseQuery } from '../baseQuery';

type PutTaskClosePayload = {
  note: string;
  taskId: number;
  noteTypeId?: number;
};

export const putTaskClose = async ({ note, taskId, noteTypeId }: PutTaskClosePayload) => {
  const data = await baseQuery('task/close', {
    type: 'PUT',
    body: {
      task_id: taskId,
      note,
      note_type_ID: noteTypeId,
    },
  });

  return data;
};
